module.exports = __webpack_public_path__ + "img/guide_dir_07.09569416.png";